(function () {
  if (typeof window.selectCardSize !== 'undefined') return;

  window.selectCardSize = function (btn, variantId) {
    var card = btn.closest('.product-card');
    if (!card) return;

    var list = btn.closest('.product-card__sizes-list');
    if (list) {
      var buttons = list.querySelectorAll('.product-card__size-item');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove('is-selected');
      }
    }
    btn.classList.add('is-selected');

    var form =
      card.querySelector('form[action*="/cart/add"]') ||
      card.querySelector('form.shopify-product-form') ||
      card.querySelector('.product-card__actions form');

    if (form) {
      var input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = variantId;
      }

      var submitBtn =
        form.querySelector('button[type="submit"]') ||
        card.querySelector('.product-card__actions button[type="submit"]');

      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('disabled');
      }
    }
  };

  function initProductCardSizes() {
    var productCards = document.querySelectorAll('.product-card');
    productCards.forEach(function (card) {
      var sizeList = card.querySelector('.product-card__sizes-list');
      if (!sizeList) return;

      var selectedBtn = sizeList.querySelector('.product-card__size-item.is-selected');
      if (selectedBtn) {
        var cardForm =
          card.querySelector('form[action*="/cart/add"]') ||
          card.querySelector('form.shopify-product-form') ||
          card.querySelector('.product-card__actions form');
        if (!cardForm) return;

        var submitBtn =
          cardForm.querySelector('button[type="submit"]') ||
          card.querySelector('.product-card__actions button[type="submit"]');
        if (submitBtn && submitBtn.disabled) {
          var input = cardForm.querySelector('input[name="id"]');
          if (input && input.value) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('disabled');
          }
        }
      } else {
        var firstBtn = sizeList.querySelector(
          '.product-card__size-item.button:not(.button--disabled):not(.sold-out)'
        );
        if (firstBtn && firstBtn.getAttribute('onclick')) {
          var match = firstBtn
            .getAttribute('onclick')
            .match(/selectCardSize\([^,]+,\s*['"]?(\d+)['"]?\)/);
          if (match && match[1]) {
            window.selectCardSize(firstBtn, match[1]);
          }
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCardSizes);
  } else {
    initProductCardSizes();
  }

  setTimeout(initProductCardSizes, 100);
})();
